__turbopack_context__.v({
  "accent": "_4jKnka_accent",
  "backdrop": "_4jKnka_backdrop",
  "berry-moderate": "_4jKnka_berry-moderate",
  "berry-standard": "_4jKnka_berry-standard",
  "berry-strong": "_4jKnka_berry-strong",
  "berry-subtle": "_4jKnka_berry-subtle",
  "dark": "_4jKnka_dark",
  "dark-scheme": "_4jKnka_dark-scheme",
  "info-strong": "_4jKnka_info-strong",
  "info-subtle": "_4jKnka_info-subtle",
  "inverse": "_4jKnka_inverse",
  "light-scheme": "_4jKnka_light-scheme",
  "moss-moderate": "_4jKnka_moss-moderate",
  "moss-standard": "_4jKnka_moss-standard",
  "moss-strong": "_4jKnka_moss-strong",
  "moss-subtle": "_4jKnka_moss-subtle",
  "smoke-moderate": "_4jKnka_smoke-moderate",
  "smoke-standard": "_4jKnka_smoke-standard",
  "smoke-strong": "_4jKnka_smoke-strong",
  "smoke-subtle": "_4jKnka_smoke-subtle",
  "standard": "_4jKnka_standard",
  "subtle": "_4jKnka_subtle",
  "success-moderate": "_4jKnka_success-moderate",
  "success-strong": "_4jKnka_success-strong",
  "warning-moderate": "_4jKnka_warning-moderate",
  "warning-strong": "_4jKnka_warning-strong",
});
